import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TutorialVideosWidgetComponent, VideoDialogComponent } from './tutorial-videos-widget.component';

// Angular Material
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';

// Safe Pipe
import { SafePipe } from '../../../shared/pipes/safe.pipe';

@NgModule({
  declarations: [
    TutorialVideosWidgetComponent,
    VideoDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    SafePipe
  ],
  exports: [
    TutorialVideosWidgetComponent
  ]
})
export class TutorialVideosWidgetModule { }
